import { createSlice } from "@reduxjs/toolkit";

const filterSlice = createSlice({
  name: "filter",
  initialState: {
    filterVideos: [],
  },
  reducers: {
    filterVideo: (state, action) => {
      state.filterVideos.push(...state.filterVideos, ...action.payload);
    },
  },
});

export const { filterVideo } = filterSlice.actions;
export default filterSlice.reducer;
